/** Products page: site-wide "Translate catalog" (status counts + AI job that keeps running on the server) and its banner. */
import React, { useState } from 'react';
import { Button, Modal, Table, Typography } from 'antd';
import { TranslationOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../shared/i18n';
import { AiCreditBadge, AiJobBanner, reportAiError, startAi } from './ai';
import { sitePath, toastErr, useSite } from './common';
import { langName } from './TranslationsCard';

const { Text } = Typography;
const TYPES = ['product', 'collection', 'post', 'page'];

export const TranslateCatalogBanner = () => {
    const { siteId } = useSite();
    return <AiJobBanner siteId={siteId} kinds={['translate_catalog']} />;
};

const TranslateCatalogButton = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { api, siteId } = useSite();
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(null);
    const [busy, setBusy] = useState(false);
    const show = async () => {
        setOpen(true);
        try { setStatus(await api.get('/translations/status')); } catch (e) { toastErr(e); setOpen(false); }
    };
    const start = async () => {
        setBusy(true);
        try {
            await startAi(siteId, 'translate_catalog', {});
            window.dispatchEvent(new Event('yc-ai-job-started'));
            setOpen(false);
        } catch (e) { reportAiError(e); } finally { setBusy(false); }
    };
    const label = { product: t('Products', { context: 'shop' }), collection: t('Collections'), post: t('Posts'), page: t('Pages') };
    const langs = status?.languages || [];
    const rows = langs.map((l) => ({ lang: l, ...(status.translated?.[l] || {}) }));
    return (
        <>
            <Button icon={<TranslationOutlined />} onClick={show}>{t('Translate catalog')}</Button>
            <Modal open={open} title={t('Translate catalog')} onCancel={() => setOpen(false)} destroyOnHidden width={560}
                footer={status && langs.length ? <><AiCreditBadge /> <Button type="primary" loading={busy} onClick={start}>{t('Translate missing with AI')}</Button></> : null}>
                {status && !langs.length && <Text type="secondary">{t('No other languages yet.')} <a onClick={() => navigate(sitePath(siteId, 'settings/general'))}>{t('Add languages in settings')}</a></Text>}
                {status && langs.length > 0 && (
                    <Table size="small" rowKey="lang" pagination={false} dataSource={rows} scroll={{ x: 440 }}
                        columns={[
                            { title: t('Language'), dataIndex: 'lang', render: (l) => langName(l, i18n?.language) },
                            ...TYPES.map((x) => ({ title: label[x], key: x, align: 'right', render: (_, r) => `${r[x] || 0}/${status.totals?.[x] ?? 0}` })),
                        ]} />
                )}
            </Modal>
        </>
    );
};

export default TranslateCatalogButton;
